import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { EstateTopRightFunction } from '@/features/estates/components/estate-top-right-function';
import { EstateBreadcrumb } from '@/features/estates/components/estateBreadcrumb';

const Component = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout'
)({
  component: Component,
  staticData: {
    breadcrumb: EstateBreadcrumb,
    topRightFunction: EstateTopRightFunction,
  },
});
